import { useMutation } from "@apollo/client/react";
import GET_USER_GROUP from "../../queries/rolesAndPermissions/getUserGroup";
import { SET_MEMBER_PERMISSIONS } from "../../mutations/rolesAndPermissions/setMemberPermissions";

export const useSetMemberPermissions = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [setMemberPermissions, { data, loading, error }] = useMutation(
    SET_MEMBER_PERMISSIONS,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_USER_GROUP],
      awaitRefetchQueries: true,
    },
  );

  return { setMemberPermissions, data, loading, error };
};
